<template>
    <div v-if="!display_qr">
    <DepositTopCard :text="$t('common.deposite')" :sub-text="$t('common.subText')"
        @close-popup="backNavigate" :show-fund="true" @go-to-fund="goToFund" :hideBacKIcon="footerSelected != '1'"/>
        <div style="height: 150px; background-color: #024A49;border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;"></div> 
        <div class="deposit_container">
           <div class="custom_theme_tabs">
              <div class="tab_title_box">
                  {{ $t('common.paymentChannel') }}
               </div>
            <van-tabs :model-value="props.dataSet.activeChannel.id" class="inner_channel_tabs" :border="false"
               type="card" @click-tab="handleTabClick" swipe-threshold="4">
              <van-tab v-for="item in dataSet.channelList" :key="item.id" :title="item.name" :name="item.id" />
            </van-tabs>
           </div>
           <div
            v-if="props.dataSet.activeChannel.channelType == '3' || props.dataSet.activeChannel.channelType == '4' || props.dataSet.activeChannel.channelType == '5'">
            <ErcCard :address="props.dataSet.ercCode" :minAmount="props.dataSet.minErcAmount"
                :maxAmount="props.dataSet.maxErcAmount" :typeTitle="props.dataSet.activeChannel.name" />
            </div>
            <div v-else>
            <!-- <div class="line"></div> -->
            <div class="bonus_select">
                <van-checkbox v-model="selecTopup">{{ $t('deposit.promotions') }}</van-checkbox>
            </div>
            <div class="deposit_notice">
                <img src="@/assets/loginRegister/notice.png" alt="">
                {{ $t('deposit.bonuseRedeem') }} {{ dataSet.turnOverValue }}x {{ $t('deposit.invoicing') }}
            </div>
            <div class="sub_container">
                <InputField v-model="selectedAmount" :labelText="dataSet.min_amount + ' - ' + dataSet.max_amount"
                    :isTopupVisible="selecTopup" :giftAmount="dataSet.giftAmount" />
                <div v-if="dataSet.activeChannel.channelType == '7' || dataSet.activeChannel.channelType == '2'">
                    <div class="input_field">
                        <div class="inputLabel">CPF ID</div>
                        <van-field v-model="cpfID" type="number" :placeholder="$t('withdraw.cpfIdPlaceholder')">
                            <template #left-icon>
                                <div class="left-wrapper">
                                    <img src="@/assets/themeFour/CPF.png" alt="CPF" class="cpf-icon" />
                                </div>
                            </template>
                            <template #right-icon>
                                <div class="right-wrapper">
                                    <van-icon v-if="cpfID" name="clear" class="custom-clear" @click.stop="onClear" />
                                    <!-- <van-icon name="credit-pay" /> -->
                                </div>
                            </template>
                        </van-field>
                    </div>
                    <div class="errorText" v-if="dataSet.showCPFIdError">
                        {{ $t('withdraw.cpfErrorText') }}</div>
                </div>

                <van-row class="amount_card_list">
                    <van-col span="8" v-for="item in dataSet.amountList" :key="item.fillValue" style="padding: 5px;">
                        <AmountCard :amount="item.fillValue" :isActiveAmount="dataSet.selectedAmount == item.fillValue"
                            :giftRatio="item.giftRatio" :isTopupVisible="selecTopup"
                            @handleCardClick="selectAmountCard(item)" />
                    </van-col>
                </van-row>

                <van-row class="note_text" v-if="selecTopup">
                    <van-col span="4">
                        <img src="@/assets/deposit/deposit_bonus.png" alt="">
                    </van-col>
                    <van-col span="20"> {{ $t('common.deposite') }} R$ {{ formatCurrency(selectedAmount) }} {{
                        $t('deposit.receive') }}
                        R$
                        {{ formatCurrency(dataSet.giftAmount) }}
                        {{ $t('deposit.asaGift') }}.</van-col>
                </van-row>
                <div v-if="userStore.isEnableRechargeNotice && dataSet.activeChannel.rechargeNotice" class="descriptionContainer">
                    <div class="noticeText">{{ $t('common.notice') }}</div>
                    <div v-html="dataSet.activeChannel.rechargeNotice"></div>
             </div>
            </div>
            
            <div class="btn_container" :class="{ 'with-footer': footerSelected != '1' }">
                <MainButton :title="$t('common.deposite')" :activeStatus="dataSet.isFillField" @click="confirmDeposit"
                    :radius="'8px'" :btn-padding="'28px'" />
            </div>
        </div>
       </div>
    </div>   
    <div v-else >
        <QRPage :show="display_qr" :iframeUrl="iframeUrl" :selectedAmountVal="amountValue" @close="display_qr = false"
            @goTo="goToFund" />
    </div>
    <div v-if="userStore.footerComponent && footerSelected != '1'">
        <MainFooter :itemData="userStore.footerComponent" :activeFooter="2" />
    </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from 'vue';
import InputField from './components/inputField.vue';
import AmountCard from './components/amountCard.vue';
import { PayChannel } from '@/types/common';
import { formatCurrency } from '@/utils/commonFunction';
import { useUserStore } from '@/stores/user';
import { DepositData } from '@/view/deposit/supportScript';
import MainButton from '../../themeFour/components/common/mainButton.vue';
import CustomHeader from '../components/common/customHeader.vue';
import DepositTopCard from '../components/common/topHeaderCard.vue';
import { useRouter } from 'vue-router';
import ErcCard from '@/themes/themeFour/deposit/components/ercCard.vue';
import QRPage from './components/QRPage.vue';
import MainFooter from '../components/common/mainFooter.vue';
const props = defineProps<{
    dataSet: DepositData
    isComponentUse?: boolean
}>()
const selecTopup = ref(props.dataSet.selecTopup)
const selectedAmount = ref(props.dataSet.selectedAmount)
const footerSelected = localStorage.getItem('showDepositBackIcon')
const amountValue = ref()
const cpfID = ref(props.dataSet.cpfID)
const userStore = useUserStore()
const router = useRouter()
const emit = defineEmits(['selectChannel', 'updateSelecTopup', 'updateSelectedAmount', 'updateCpfID', 'selectAmountCard', 'confirmDeposit'])
const activeTab = ref(0);
const display_qr = ref(false);
const selectChannel = (item: PayChannel) => {
    emit('selectChannel', item)
}
watch(selecTopup, (val) => {
    emit('updateSelecTopup', val)
})
watch(selectedAmount, (val) => {
    emit('updateSelectedAmount', val)
})
watch(cpfID, (val) => {
    emit('updateCpfID', val)
})
watch(() => props.dataSet, (newVal) => {
    selectedAmount.value = newVal.selectedAmount
}, { deep: true, immediate: true })

const selectAmountCard = (select: any) => {
    selectedAmount.value = select.fillValue
    emit('selectAmountCard', select)
}
const confirmDeposit = () => {
    emit('confirmDeposit')
}
const onClear = () => {
    cpfID.value = ''
}
const backNavigate = () => {
    userStore.setRechargeBonusType(0)
    userStore.setTakeFirstDeposit(false)
    router.go(-1)
    localStorage.setItem('showDepositBackIcon', '0')
}
const goToFund = () => {
    router.replace({ path: '/fundsHistory', query: { tabIndex: 0 } })
}
const iframeUrl = ref('')
const triggerConfirm = (url: string) => {
    display_qr.value = true
    iframeUrl.value = url
    amountValue.value = selectedAmount.value
}

const handleTabClick = (tabObject: any) => {
    const id = tabObject.name;
    const selected = props.dataSet.channelList.find(item => String(item.id) === String(id));
    if (selected) {
        emit('selectChannel', selected);
    }
};
onMounted(() => {
    const footerPopupOpen = localStorage.getItem('footerPopupOpen')
    if (footerPopupOpen == '2') {
       localStorage.setItem('showDepositBackIcon', '0')
    }
})
defineExpose({
    triggerConfirm
})

</script>
<style scoped>
.deposit_container {
    /* background: #003130; */
    display: flex;
    /* margin-top: 150px;  */
    flex-direction: column;
    font-size: 20px;
    /* height: calc(100vh - 170px); */
    overflow-y: auto;
    padding-bottom: 180px;
    scrollbar-width: none;
}

.deposit_container::-webkit-scrollbar {
    display: none;
}

.channel_text {
    color: #ffffffd9;
    font-size: 14px;
    padding-top: 15px;
    padding-left: 25px;
}

.channel_list {
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    white-space: nowrap;
    padding: 15px 0px;
}

.channel_list::-webkit-scrollbar {
    display: none;
}

.channel_card {
    border-radius: 5px;
    width: 70px;
    color: #ffffff;
    background-color: #ffffff26;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    padding: 7px;
    margin-right: 10px;
    font-size: 15px;
    height: 35px;
    width: 100%;
}

.active_channel {
    background: linear-gradient(180deg, #35A5F8 0%, #0268CB 100%);
    color: #ffffff;
    border-radius: 5px;
}

.deposit_notice {
    display: flex;
    align-items: center;
    border-radius: 5px;
    color: #ffffffa6;
    font-size: 14px;
    margin: 0px 25px 0;
    background-color: #ffffff26;
    padding: 15px;
}

.deposit_notice img {
    width: 20px;
    opacity: 0.5;
    height: 20px;
    padding-right: 10px;
}

.amount_card_list {
    padding: 15px 0;
}

.btn_container {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 5px 18px;
    background: #003130;
    z-index: 100;
    width: 100%;
    box-sizing: border-box;
}

.btn_container.with-footer {
    padding-bottom: 100px;
}

.bonus_select {
    padding: 15px 25px 15px;
}

.bonus_select>>>.van-checkbox__label {
    color: #ffffff73;
    font-size: 14px;
}

.bonus_select>>>.van-checkbox__icon--round {
    font-size: 15px;
    background: #fff;
    border-radius: 30px;
}

.bonus_select>>>.van-checkbox__icon--checked .van-icon {
    background-color: #0DB0AE !important;
    border-color: #0DB0AE !important;
}

.note_text {
    padding: 10px;
    border-radius: 10px;
    background-color: #ffffff14;
    font-size: 12px;
    color: #ffffffa6;
}

.note_text .van-col {
    display: flex;
    align-items: center;
}

.note_text img {
    width: 35px;
}

.line {
    height: 1.5px;
    background: #1a233e;
    margin: 0 15px; 
}

.sub_container {
    padding: 0 25px;
}

.sub_container ::v-deep .van-field {
    border-radius: 8px;
    padding: 2vh !important
}

.btn_container ::v-deep .defaultButton .van-button--default {
    border-radius: 10px !important;
    padding: 1.5vw 0;
}

.amount_card {
    border-radius: 5px;
}

.input_field>>>.van-field {
     border-radius: 8px;
    background: #002121 !important;
    border: 0.5px solid rgb(13, 176, 174);
    padding: 8px 12px !important;
    align-items: center;
    height: 60px;
    transition: border-color 0.3s ease;
    margin-top: 10px;
}

.input_field>>>.van-field__control {
   color: #ffffff !important;
  font-weight: 700;
  font-size: 16px;
}

.input_field>>>.van-field__control::placeholder {
     color: #4a6b6a !important;
  font-weight: 700;
}

.input_field {
    padding: 10px 0;
}

.inputLabel {
    color: #668685;
    font-size: 14px;
    margin-bottom: 10px;
    font-weight: 600;
}

.errorText {
    color: red;
    font-size: 12px;
}

.right-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
}

.left-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
    padding-right: 10px;
}

.cpf-icon {
    width: 18px;
    height: 100%;
}

.descriptionContainer {
    padding: 15px;
    background: #ffffff2f;
    font-size: 14px;
    color: #fff;
    border-radius: 5px;
    margin: 15px 0px;
}

.noticeText {
    font-size: 14px;
    font-weight: bold;
    padding: 0 0 5px;
    color: #ffffffa6;
}

div :deep(p) {
    margin-bottom: 10px;
    margin-top: 0px;
    color: #fff;
    line-height: 1.5;
}

div :deep(br) {
    content: "";
    margin: 5px 0;
    display: block;
}

.custom_theme_tabs {
    padding: 0 15px;
}

.inner_channel_tabs :deep(.van-tabs__wrap) {
    border: none;
    display: flex;
    align-items: center;
    flex-shrink: 0;
}

.inner_channel_tabs :deep(.van-tabs__wrap .van-tabs__nav--card) {
    scrollbar-width: none !important;
}

.custom_theme_tabs :deep(.van-tab) {
    color: #ffffffa6;
    font-size: 18px;
    /* padding: 0 25px; */
    flex: none;
    font-weight: 700;
}

.custom_theme_tabs :deep(.van-tabs__wrap) {
    height: 60px;
}

.tab_title_box {
   font-size: 16px;
   color: #fff;
   font-weight: 700; 
   padding: 20px 0px 10px 0px;
}

.inner_channel_tabs :deep(.van-tabs__nav--card) {
    border: none;
    background: transparent;
    margin: 15px 0;
    height: auto;
    font-weight: 600;
}

.inner_channel_tabs :deep(.van-tab) {
    background-color: #ffffff26;
    color: #ffffff;
    border: none;
    margin-right: 10px;
    border-radius: 7px;
    padding: 0 10px;
    height: 40px;
    line-height: 35px;
    min-width: 80px;
    display: flex;
    text-align: center;
    flex: none;
}

.inner_channel_tabs :deep(.van-tab--active) {
    background: rgb(13, 176, 174) !important;
    color: #ffffff !important;
}

.inner_channel_tabs :deep(.van-tabs__wrap) {
    border: none;
}

@media (min-width: 1440px) {
    .deposit_notice {
        padding: 15px;
    }

     .channel_card,
    .balance_text,
    .sub_container,
    .sub_container ::v-deep .van-field,
    .btn_container ::v-deep .defaultButton .van-button--default {
        font-size: 2vh;
    }

    .inner_channel_tabs :deep(.van-tab) {   
    height: 45px;
}
}

@media (min-width: 1920px) {

    .channel_text,
    .deposit_notice,
    .amount_card,
    .active_channel {
        font-size: 2vh !important;
    }
    
    .channel_card,
    .balance_text,
    .sub_container,
    .sub_container ::v-deep .van-field,
    .btn_container ::v-deep .defaultButton .van-button--default {
        font-size: 2vh;
    }
   
     .inner_channel_tabs :deep(.van-tab) {
     height: 45px;
     }
    .custom_theme_tabs :deep(.van-tab) {
    font-size: 18px;
    }
    
    .deposit_notice {
        padding: 15px;
    }
}

@media (max-width: 360px) {


  .custom_theme_tabs {
    padding: 10px 10px;
  }

  .custom_theme_tabs :deep(.van-tabs__wrap) {
    height: 45px;
  }

  .custom_theme_tabs :deep(.van-tab) {
    font-size: 14px;
  }

  .tab_title_box {
    font-size: 14px;
    padding: 5px 0px 10px 0px;
  }

  .inner_channel_tabs :deep(.van-tab) {
    height: 36px;
    line-height: 28px;
    min-width: 60px;
    font-size: 12px;
    padding: 0 8px;
  }

  .sub_container {
    padding: 0 15px;
  }
  
  .sub_container :deep(.van-field){
    padding : 8px !important
  }

  .deposit_notice {
    font-size: 12px;
    padding: 10px;
    margin: 0 15px;
  }

  .deposit_notice img {
    width: 16px;
    height: 16px;
  }

  .bonus_select {
    padding: 10px 15px;
  }

  .inputLabel {
    font-size: 12px;
  }

  .input_field>>>.van-field {
    padding: 8px 12px !important;
    font-size: 12px;
    height: 50px;
  }

  .amount_card_list {
    padding: 10px 0;
  }

  .amount_card {
    font-size: 12px;
  }

  .btn_container {
    padding: 20px;
  }

  .note_text {
    font-size: 11px;
  }

  .note_text img {
    width: 25px;
  }
}
</style>